export default [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/layout'),
    redirect: '/home/index',
    children: [
      {
        path: 'index',
        name: 'homeIndex',
        component: () => import('@/views/web/home/index'),
        meta: {
          icon: 'home',
          auth: true,
          trackCode: 'menu-24',
          trackName: '首页 - 工作台',
          activeMenu: '/home/index',
        },
      },
    ],
  },
];
